import { IAttachment } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

export type FileLink = number | string | Partial<IAttachment>;

export abstract class Downloader {
	abstract download(link: string, fileName?: string): Observable<any>;
	abstract downloadAllFilesInComment(commentId: number): Observable<any>;
	abstract createDownloadLink(fileOrId: FileLink): string;
	abstract createPreviewPdfLink(fileOrId: FileLink): string;
	abstract createPreviewOfficeWebAppLink(fileOrId: FileLink): string;
	abstract createPreviewWebDAVLink(fileOrId: FileLink, name: string): string;
	abstract createPreviewTextLink(fileOrId: FileLink): string;
	abstract createPreviewImageLink(fileOrId: FileLink): string;
}
